import { SelectItem } from 'primeng/api';
import { PortalUser } from '../domain/user';
import { CountryLite } from './system-config/country';
import { ConfigValue } from './system-config/config-value';
import { ReadableConfigValue } from './system-config/readable-config-value';

export interface CompanyInstruction {
  id?: number;
  version?: number;
  creationDate?: string;
  lastModified?: string;
  lastModifiedBy?: PortalUser;
  instructionType?: CompanyInstructionType;
  instructionText?: string;
  products?: ConfigValue[];
  countries?: CountryLite[];
  sourceType?: InstructionSourceType;
  category?: InstructionCategory;
  projectType?: ReadableConfigValue;
}

export interface CompanyInstructionGrouped {
  clientCareInstructions: CompanyInstruction[];
  estimateInstructions: CompanyInstruction[];
  invoiceInstructions: CompanyInstruction[];
  standingInstructions: CompanyInstruction[];
  recordalEstimateInstructions: CompanyInstruction[];
  recordalProjectInstructions: CompanyInstruction[];
}

export interface CompanyInstructionQuery {
  companyId?: number;
  instructionId?: number;
  instructionType?: CompanyInstructionType;
  groupId?: number;
  estimateId?: number;
  projectId?: number;
}

export interface CompanyInstructionGroupedQuery {
  taskId?: number;
  estimateId?: number;
  projectId?: number;
}

export enum CompanyInstructionType {
  ClientCareGeneral = 'GENERAL_FILING_AND_TRANSLATION',
  GeneralRenewals = 'GENERAL_RENEWALS',
  ClientCareIntake = 'ESTIMATE_PROJECT_ENTRY',
  ClientCarePreIntake = 'COMPANY_SELECTION',
  ClientCarePostIntake = 'SENDING_ESTIMATE',
  Invoice = 'INVOICE',
  Project = 'STANDING',
  Estimate = 'ESTIMATE',
  RecordalProject = 'RECORDAL_PROJECT',
  RecordalEstimate = 'RECORDAL_ESTIMATE',
}

export const COMPANY_INSTRUCTION_TYPES: SelectItem[] = [
  { label: 'Filing & Translation Instruction', value: CompanyInstructionType.ClientCareGeneral },
  { label: 'Renewals Instruction', value: CompanyInstructionType.GeneralRenewals },
  { label: 'Company Selection Instructions', value: CompanyInstructionType.ClientCarePreIntake },
  { label: 'Estimate/Project Entry Instructions', value: CompanyInstructionType.ClientCareIntake },
  { label: 'Sending Estimate Instructions', value: CompanyInstructionType.ClientCarePostIntake },
  { label: 'Invoice Instructions', value: CompanyInstructionType.Invoice },
  { label: 'Project Instructions', value: CompanyInstructionType.Project },
  { label: 'Estimate Instructions', value: CompanyInstructionType.Estimate },
  { label: 'Project Instructions', value: CompanyInstructionType.RecordalProject },
  { label: 'Estimate Instructions', value: CompanyInstructionType.RecordalEstimate },
];

export enum InstructionSourceType {
  ClientProfile = 'CLIENT_PROFILE',
  Team = 'TEAM',
  StandardFiling = 'STANDARD_FILING',
  StandardTranslation = 'STANDARD_TRANSLATION',
  StandardProjectType = 'STANDARD_PROJECT_TYPE',
}

export const INSTRUCTION_SOURCE_TYPES: SelectItem[] = [
  { label: 'Client Profile', value: InstructionSourceType.ClientProfile },
  { label: 'Team', value: InstructionSourceType.Team },
  { label: 'Standing Instructions (Filing)', value: InstructionSourceType.StandardFiling },
  { label: 'Standing Instructions (Translation)', value: InstructionSourceType.StandardTranslation },
  { label: 'Standing Instructions (Project Type)', value: InstructionSourceType.StandardProjectType },
];

export enum InstructionCategory {
  General = 'GENERAL',
  Specific = 'SPECIFIC',
}

export enum InstructionRevisionType {
  Add = 'ADD',
  Mod = 'MOD',
  Del = 'DEL',
}

export interface CompanyInstructionRevision {
  revisionNumber?: number;
  revisionDate?: string;
  revisionType?: InstructionRevisionType;
  instruction?: CompanyInstruction;
}

export interface CompanyInstructionRevisionGrouped {
  clientCareInstructions?: CompanyInstructionRevision[];
  standingInstructions?: CompanyInstructionRevision[];
  estimateInstructions?: CompanyInstructionRevision[];
  invoiceInstructions?: CompanyInstructionRevision[];
  recordalProjectInstructions?: CompanyInstructionRevision[];
  recordalEstimateInstructions?: CompanyInstructionRevision[];
}
